const EAN_LENGTH_PATTERN = /^\d{8,14}$/;

export function normalizeScannedEan(value) {
  const digits = String(value ?? '').replace(/\D/g, '');
  return EAN_LENGTH_PATTERN.test(digits) ? digits : '';
}

export function classifyEanSearchInput(value) {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return { kind: 'empty', normalized: '', valid: true };

  const compact = trimmed.replace(/\s+/g, '');
  if (/^\d+$/.test(compact)) {
    if (EAN_LENGTH_PATTERN.test(compact)) {
      return { kind: 'ean', normalized: compact, valid: true };
    }

    return {
      kind: 'invalid-ean',
      normalized: compact,
      valid: false,
      message: 'Ein EAN-Code muss aus 8 bis 14 Ziffern bestehen.',
    };
  }

  return { kind: 'text', normalized: trimmed, valid: true };
}
